import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { routes } from '../../constants';
import { selectUser } from '../../reducers/user.selectors';
import useRouter from '../../utils/useRouter';

const AI_ONLY_PLAN_ALLOWED_PATHS = [
  `/${routes.aiTools.root}`,
  `/${routes.myContents.root}`,
  `/${routes.aiAssistantHistory.root}`,
  `/${routes.personalDetails.root}/profil`,
  `/${routes.personalDetails.root}/konto`,
  `/${routes.onboardingPage.root}`,
  `/${routes.stripeUpgrade.root}`,
];

const isAiOnlyPlanAllowedPath = (pathname: string) => {
  return AI_ONLY_PLAN_ALLOWED_PATHS.some(
    (allowed) => pathname === allowed || pathname.startsWith(`${allowed}/`)
  );
};

const RedirectIfAiOnlyPlan: React.FC = ({ children }) => {
  const user = useSelector(selectUser);
  const { match, router } = useRouter();
  const pathname = match.location.pathname;

  const shouldRedirect = user?.isAiOnlyUser && !isAiOnlyPlanAllowedPath(pathname);

  useEffect(() => {
    if (shouldRedirect) {
      router.replace(`/${routes.aiTools.root}`);
    }
  }, [shouldRedirect, router]);

  if (shouldRedirect) {
    return null;
  }

  return <>{children}</>;
};

export default RedirectIfAiOnlyPlan;
